import i18next, { ThirdPartyModule } from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './lang/en';

const resources = {
    en: {
        translation: enTranslation,
    },
};

const changeHtmlLanguage: ThirdPartyModule = {
    type: '3rdParty',
    init: i18n => {
        i18n.on('languageChanged', l => document.documentElement.lang = l);
    },
};

i18next
    .use(initReactI18next)
    .use(changeHtmlLanguage)
    .init({
        resources,
        fallbackLng: 'en',
    });
